(
    function (skyward, $)
    {
        skyward.hierarchy = skyward.hierarchy || {};

        skyward.hierarchy.initiate = function (lookupId, url)
        {
            var fullURL = url.replace("~/", skyward.global.virtualDir);
            $.ajax(fullURL,
                {
                    type: "POST",
                    dataType: "JSON",
                    success: function (data)
                    {
                        $("#" + lookupId + "_main").html(data.html);
                        skyward.window.notifyDOMLoad("#" + data.selector);
                    }
                }
            );
        };

        skyward.hierarchy.toggle = function ()
        {
            var button = $(this);
            var controlName = button.data("controlname");
            var nodeValue = button.data("nodevalue");
            var main = $("#" + controlName + "_main");
            var lookupId = main.data("lookup-id");
            var expandUrl = main.data("expand-url");
            var buttonName = controlName + "_togglebutton_" + nodeValue;
            var rowName = controlName + "_row_" + nodeValue;
            var rowSelector = "#" + rowName;

            button.toggleClass("expanded");
            var svg = button.find('svg');
            if (!button.attr('disabled'))
            {
                if (button.hasClass("expanded"))
                {
                    skyward.svg.swapSvg(svg, "Collapse", "Hierarchy");
                    var row = $(rowSelector);
                    if (!row.data("childrenLoaded"))
                    {
                        button.attr('disabled', true);
                        var fullUrl = expandUrl.replace("~/", skyward.global.virtualDir) + "/" + lookupId + "/" + controlName + "/" + nodeValue;
                        $.ajax(fullUrl,
                            {
                                type: "POST",
                                dataType: "JSON",
                                success: function (data)
                                {
                                    $("#" + controlName + "_row_" + nodeValue).after(data.html);
                                    row.data("childrenLoaded", true);
                                    skyward.window.notifyDOMLoad(data.selector);
                                    button.attr('disabled', false);
                                }
                            }
                        );
                    }
                    else
                    {
                        // Row has been loaded.  Just display it.
                        $("[id^='" + rowName + "-'][data-depth='" + (1 + $(rowSelector).data("depth")) + "']").removeClass("collapsed");

                        $(".spacerRow[data-hierarchy-row-path=" + rowName + "]").removeClass("collapsed");
                        $(".objectSpacerRow[data-hierarchy-row-path=" + rowName + "]").removeClass("collapsed");
                    }
                }
                else
                {
                    skyward.svg.swapSvg(svg, "Expand", "Hierarchy");
                    // Collapsing.
                    $("[id^='" + rowName + "-']").addClass("collapsed");
                    $("[id^='" + buttonName + "-']").removeClass("expanded");

                    $(".spacerRow[data-hierarchy-row-path=" + rowName + "]").addClass("collapsed");
                    $(".objectSpacerRow[data-hierarchy-row-path^=" + rowName + "]").addClass("collapsed");
                }
            }
        };

        skyward.hierarchy.initializeOrganizationChart = function (containerID)
        {
            var hierarchy = $("#" + containerID);
            var hiddenField = hierarchy.siblings("#SelectedRecord").eq(0).val("null");
            var addOrMoveRecord = $("#AddOrMoveRecord").val("null");
            var newTopLevelButton = $("#btnAddNewTopLevelRelationship");
            var newButton = $("#btnAddNewRelationship");
            var moveButton = $("#btnMoveRelationship");
            var deleteButton = $("#btnDeleteRelationship");
            var openButton = $("#btnOpenRelationship");
            var massAddButton = $("#btnMassAddRelationship");
            var selectedRecord = hierarchy.find(".hierarchyrow .selected").eq(0);
            var hierarchyContainer = hierarchy.parents(".hierarchyContainer");

            if (selectedRecord.length > 0)
            {
                hiddenField.val(selectedRecord.attr("data-recordid"));
                toggleButtons(true);
            }

            hierarchyContainer.on("click", ".hierarchyrow .selectable", function ()
            {
                selectedRecord = $(this);

                hierarchy.find(".hierarchyrow .selectable").removeClass("selected");
                selectedRecord.addClass("selected");

                hiddenField.val(selectedRecord.attr("data-recordid"));
                hiddenField.change();

                toggleButtons(true);
            });

            hierarchyContainer.on("click", ".hierarchyButton", skyward.hierarchy.toggle);
            hierarchyContainer.debounce("click", ".hierarchyButton", updatePageState);

            if (hierarchyContainer.hasClass("js-hierarchyBindButtons")) {
                newTopLevelButton.click(function ()
                {
                    if (!newTopLevelButton.hasClass("ui-disabled"))
                    {
                        addOrMoveRecord.val(hiddenField.val());
                        skyward.window.loadContent('popup', 'Workflow', 'WorkflowInstance', 'Create/Position/OrganizationChartRelationship/Add', null, { "Workflow.OrganizationChartID": hierarchy.attr("data-lookup-id"), "Workflow.TopLevelRelationship": true }, null, null, null, false);
                    }
                });
            
                newButton.click(function ()
                {
                    if (!newButton.hasClass("ui-disabled"))
                    {
                        addOrMoveRecord.val(hiddenField.val());
                        skyward.window.loadContent('popup', 'Workflow', 'WorkflowInstance', 'Create/Position/OrganizationChartRelationship/Add', null, { "Workflow.OrganizationChartID": hierarchy.attr("data-lookup-id"), "Workflow.PositionIDSupervisor": hiddenField.val() }, null, null, null, false);
                    }
                });

                moveButton.click(function ()
                {
                    if (!moveButton.hasClass("ui-disabled"))
                    {
                        addOrMoveRecord.val(hiddenField.val());
                        var fiscalYearID = moveButton.data("organizationalchartfiscalyearid");
                        skyward.window.loadContent('popup', 'Workflow', 'WorkflowInstance', 'Create/Position/OrganizationChartRelationship/Move', null, { "Workflow.OrganizationChartRelationship.OrganizationChartID": hierarchy.attr("data-lookup-id"), "Workflow.OrganizationChartRelationship.PositionIDSupervisor": hiddenField.val(), "Workflow.FiscalYearID": fiscalYearID }, null, null, null, false);
                    }
                });

                deleteButton.click(function ()
                {
                    if (!deleteButton.hasClass("ui-disabled"))
                    {
                        if ($(".currentRecordContent .selected").attr("data-hasChildren") == "false")
                        {
                            skyward.window.loadContent('full', 'Position', 'OrganizationChartRelationship', 'Delete', $(".currentRecordContent .selected").attr("data-relationshipID"), null, null, null, null, false);
                        }
                        else
                        {
                            var fiscalYearID = deleteButton.data("organizationalchartfiscalyearid");
                            skyward.window.loadContent('popup', 'Workflow', 'WorkflowInstance', 'Create/Position/OrganizationChartRelationship/DeleteSupervisor', null, { "Workflow.OrganizationChartID": hierarchy.attr("data-lookup-id"), "Workflow.PositionIDSelected": hiddenField.val(), "Workflow.FiscalYearID": fiscalYearID }, null, null, null, false);
                        }
                    }
                });

                openButton.click(function ()
                {
                    if (!deleteButton.hasClass("ui-disabled"))
                    {
                        skyward.window.loadContent('full', 'Position', 'OrganizationChartRelationship', 'Details', $(".currentRecordContent .selected").attr("data-relationshipID"), null, null, null, null, false);
                    }
                });

                massAddButton.click(function ()
                {
                    if (!deleteButton.hasClass("ui-disabled"))
                    {
                        var fiscalYearID = massAddButton.data("organizationalchartfiscalyearid");
                        skyward.window.loadContent('popup', 'Workflow', 'WorkflowInstance', 'Create/Position/OrganizationChartRelationship/MassAdd', null, { "Workflow.OrganizationChartID": hierarchy.attr("data-lookup-id"), "Workflow.PositionIDSupervisor": hiddenField.val(), "Workflow.FiscalYearID": fiscalYearID }, null, null, null, false);
                    }
                });
            }

            function toggleButtons(enabled)
            {
                const allButtons =
                    [newTopLevelButton, newButton, moveButton, deleteButton, openButton, massAddButton]
                    .reduce((a, b) => a.add(b));
                allButtons.toggleClass("ui-disabled", !enabled).attr("aria-disabled", !enabled);
            }

            function updatePageState()
            {
                var items = [];
                var expandedButtons = $("a.expanded");
                for (var i = 0, len = expandedButtons.length; i < len; i++)
                {
                    var expandedRecord = $(expandedButtons[i]).siblings(".selectable");
                    var recordID = expandedRecord.attr("data-recordid");
                    if (recordID && recordID !== "")
                    {
                        items.push(recordID);
                    }
                }

                if (addOrMoveRecord && addOrMoveRecord.length > 0)
                {
                    var value = addOrMoveRecord.val();
                    if (value !== "null" && items.indexOf(value) === -1)
                    {
                        items.push(value);
                    }
                }

                var pageState =
                {
                    id: "ExpandTo",
                    items: [{
                        key: "value",
                        value: items.join(","),
                        skip: false
                    }]
                };

                skyward.window.updatePageState([pageState]);
            };
        };

    }(window.skyward = window.skyward || {}, window.jQuery)
);